import { useCallback, useRef } from 'react';

export default function useFirst() {
  const isFirst = useRef(true);

  const resetFirst = useCallback(() => (isFirst.current = true), []);

  const onFirst = useCallback((callback?: () => void) => {
    if (!isFirst.current) return;

    callback?.();
    isFirst.current = false;
  }, []);

  return {
    isFirst: isFirst.current,
    onFirst,
    resetFirst,
  };
}
